(function ($) {
    "use strict";

    // es5

    var forms = $('.js-form'),
        rules = {};

    if (!forms.length) return;

    forms.each(function () {
        var form = $(this);

        setupValidate(form, rules);
    });

    // Функция валидации формы
    function setupValidate(form, rules) {
        var inputs = $('.js-form-field', form),
            submitButton = $('.js-form-btn', form);

        submitButton.attr('disabled', !$('.js-form-btn-disabler').prop('checked'));

        // Задаем маски по атрибуту words (только буквы)
        $('[data-mask-words]', form).each(function () {
            $(this).inputmask("Regex", {
                regex: "^[а-яА-ЯёЁa-zA-Z -]+$",
                placeholder: ''
            });
        });

        // Задаем маски по атрибуту phone (телефон по маске)
        $('[data-mask-phone]', form).each(function () {
            $(this).inputmask({
                mask: '8 (999) 999 - 99 - 99',
                showMaskOnHover: false
            });
            rules[$(this).attr('name')] = {
                phone: true
            };
        });

        function getItem(element) {
            return $(element).closest('.form-item');
        }

        var options = {
            rules: rules,
            ignore: [],
            onkeyup: function (element) {
                getItem(element).removeClass('_invalid');
            },
            errorPlacement: function (error, element) {
                getItem(element).find('.form-item-error').text(error.text());
            },
            highlight: function (element, errorClass, validClass) {
                getItem(element).addClass('_invalid');
                getItem(element).toggleClass('_filled', $(element).is('[type="checkbox"]') ? $(element).prop('checked') : $(element).val().length > 0);
            },
            unhighlight: function (element, errorClass, validClass) {
                getItem(element).removeClass('_invalid');
            },
            onfocusout: function (element) {
                getItem(element).toggleClass('_filled', $(element).is('[type="checkbox"]') ? $(element).prop('checked') : $(element).val().length > 0);
                $(element).valid();
            },
            onclick: function (element) {
                if ($(element).hasClass('js-form-btn-disabler')) {
                    submitButton.attr('disabled', !$(element).prop('checked'));
                }
                getItem(element).toggleClass('_filled', $(element).prop('checked'));
            }
        };

        inputs.each(function () {
            getItem(this).toggleClass('_filled', $(this).is('[type="checkbox"]') ? $(this).prop('checked') : $(this).val().length > 0);
            $(this).change(function () {
                $(this).valid();
            });
            $(this).focus(function () {
                $(this).closest('.form-item').addClass('_focus');
                gaCounter('send', 'event', 'form', 'focus', $(this).attr('name'));
                yaCounter.reachGoal('form_focus');
            });
            $(this).blur(function () {
                $(this).closest('.form-item').removeClass('_focus');
            });

            if($(this).is('[type="file"]')) {
                $(this).on('input change', function () {

                    //Если крепится файл, обрезаем название пути по длине
                    if (!$(this).parents('.js-form-item').is('._invalid')) {
                        var value = $(this).val(),
                            arr = value.split('\\');

                        //if (value.length > 30) value = '..'+value.slice(-30);
                        if (value.length) value = arr[arr.length - 1] + '  (до 5 Мб)';

                        $(this).next().text(value ? value : 'Прикрепить резюме (до 5 Мб)');
                    }
                });
            }
        });

        if (form.hasClass('js-form-ajax')) {
            options.submitHandler = function (form) {
                var $form = $(form);

                $form.ajaxSubmit({
                    beforeSubmit: function () {
                        submitButton.attr('disabled', 'disabled');
                    },
                    success: function (data) {
                        //data = JSON.parse(data);
                        submitButton.removeAttr('disabled');
                        if (data.success) {
                            var parent = $form.closest('.form-container');
                            parent.addClass('_success');

                            //setTimeout(function () {
                            //    parent.removeClass('_success');
                            //    $form.get(0).reset();
                            //    parent.find('._filled').removeClass('_filled');
                            //}, 1500);
                            $(document).trigger('form:success', $form);
                        } else if (data.success === false) {
                            alert(data.message);
                        }

                        var eventLabel = $('.vacancy-promo__title').text().replace(/\r?\n/g, " ").replace(/ {2,}/g, " ");
                        gaCounter('send', 'event', 'form', 'send', eventLabel, {dimension4: eventLabel});
                        yaCounter.reachGoal('form_send');
                    }
                });
            };
        }

        form.validate(options);
    }

    $.validator.methods.email = function (value, element) {
        return this.optional(element) || /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zа-яёії\-0-9]+\.)+[a-zа-яёії]{2,}))$/i.test(value);
    };

    $.validator.addMethod(
        "phone",
        function (value, element) {
            return this.optional(element) || $(element).inputmask("isComplete");
        },
        "Введите корректный номер."
    );

})(jQuery);


// WEBPACK FOOTER //
// ./_src/js/form.js